module.exports = {
  FILE_UPLOAD_URL: process.env.VUE_APP_FILEUPLOADHOST || 'api.dev.claimgenius.com',
};
